module.exports = __webpack_public_path__ + "doctor_7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_7.jpg
// module id = 894
// module chunks = 0